import React from 'react'

import { Form, Input, Button, Row, Col, Modal, notification } from "antd";
import { createAirport } from '../../../api/airport.service';

export default function AddAirportFormModal({ fetchAirports, isModalOpen, setIsModalOpen, handleOk, handleCancel }) {

    const onFinish = async (values) => {
        try {
            await createAirport(values);
            notification.success({ message: "Airport added" });
            fetchAirports();
            setIsModalOpen(false);
        } catch (error) {
            notification.error({ message: "Operation failed!" });
            console.error("Error:", error);
        }
    };

    return (
        <>
            <Modal footer={null} destroyOnClose title="Add Airport" open={isModalOpen} onOk={handleOk} onCancel={handleCancel}>
                <Form layout="vertical" onFinish={onFinish} initialValues={{
                    airportName: "",
                    airportCode: "",
                }}>
                    <Row gutter={16}>
                        <Col span={12}>
                            <Form.Item label="Airport name" name="airportName" rules={[{ required: true, message: "Please enter airport name" }]}>
                                <Input placeholder='Enter airport name' />
                            </Form.Item>
                        </Col>
                        <Col span={12}>
                            <Form.Item label="Airport code" name="airportCode" rules={[{ required: true, message: "Please enter airport code" }]}>
                                <Input placeholder='Enter airport code' />
                            </Form.Item>
                        </Col>
                    </Row>
                    <Form.Item>
                        <Button type="primary" htmlType="submit">Submit</Button>
                    </Form.Item>
                </Form>
            </Modal>
        </>
    );
};